import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import '../styles/components/ScrollReveal.css';

/**
 * Componente wrapper para animaciones de scroll reveal
 * Minimalista, moderno y optimizado para rendimiento
 * 
 * @param {React.ReactNode} children - Contenido a animar
 * @param {string} variant - Variante de animación: 'fade-up', 'fade-in', 'slide-up', 'scale-in'
 * @param {number} delay - Delay en ms (útil para stagger effects)
 * @param {number} duration - Duración de la animación en ms
 * @param {string} className - Clases CSS adicionales
 * @param {Object} style - Estilos inline adicionales
 * @param {boolean} triggerOnce - Si solo debe animarse una vez
 */
const ScrollReveal = ({
  children,
  variant = 'fade-up',
  delay = 0,
  duration = 500,
  className = '',
  style = {},
  triggerOnce = true
}) => {
  const [ref, isVisible] = useScrollReveal({
    threshold: 0.05,
    rootMargin: '0px 0px -50px 0px',
    triggerOnce,
    delay
  });

  const animationStyle = {
    '--animation-duration': `${duration}ms`,
    ...style
  };

  return (
    <div
      ref={ref}
      className={`scroll-reveal scroll-reveal--${variant} ${isVisible ? 'scroll-reveal--visible' : ''} ${className}`}
      style={animationStyle}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;

